import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  IonModal,
  AlertController,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { getFunctions, httpsCallable } from 'firebase/functions';
import mixpanel from 'mixpanel-browser';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { IPod } from 'src/app/shared/models/item.models';
import {
  filter,
  finalize,
  Subject,
  takeUntil,
  switchMap,
  combineLatest,
  skip,
} from 'rxjs';
import { Navigation, SwiperOptions } from 'swiper';
import { AuthService } from 'src/app/firebase/auth.service';
import { StorageHelper } from 'src/app/firebase/helpers/storageHelper';
import {
  confirmForAnswers,
  confirmForDelete,
  successPodsModalData,
} from '../pods/pods';
import { PodService } from '../pods.service';
import { PodStore } from '../pod-store';
import { EventsStore } from 'src/app/events/events-store';
import { environment } from '../../../../environments/environment';
import {
  eventDiscordModalData,
  eventPremiumModalData,
  successEventModalData,
} from 'src/app/events/events';
import { PaymentsStore } from 'src/app/payments/payments-store';
import { PaymentsService } from 'src/app/payments/payments.service';
import { DateService } from 'src/app/services/date.service';
import { UserService } from 'src/app/auth/user.service';
import { ImagesService } from 'src/app/services/images.service';
import { ShareOptionsComponent } from '../../../activity-feed/post-details/share-options/share-options.component';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-pod-details',
  templateUrl: './pod-details.component.html',
  styleUrls: ['./pod-details.component.scss'],
})
export class PodDetailsComponent implements OnInit, OnDestroy {
  @Output() isClose = new EventEmitter<boolean>(false);
  @ViewChild('questionModal') questionModal: IonModal;
  isContentFlaggedModal: boolean = false;
  pod: IPod;
  podId = '';
  events;
  participants = [];
  memberRequests = [];
  userId: string;
  user;
  currentTime = new Date().getTime();
  config: SwiperOptions;
  slideIndex: number;
  gallery: string[] = [];
  galleryUrls: string[];
  itemId = '';
  isMobile = false;

  isCreator: boolean;
  isParticipant: boolean;
  isCanApprove: boolean;
  detailVisible: boolean;
  isCanEdit: boolean;

  isParticipantExist = false;
  isPendingJoinRequest: boolean;
  isCanDeleteImage = false;
  isCanFlagImage = false;

  showForDelete = false;
  showForFlag = false;
  showForAnswers = false;
  isOpenPodFormModal = false;
  isOpenAnswersModal = false;
  isOpen = false;
  isOpenFormEventModal = false;
  showSuccessModal = false;
  showEventSuccessModal = false;
  successModalData = successPodsModalData;
  eventSuccessModalData = successEventModalData;
  confirmForDelete = confirmForDelete;
  confirmForAnswers = confirmForAnswers;
  showStatusModal: boolean = false;
  itemStatus;
  maxSize = false;

  isUserPremiumModalOpen = false;
  premiumModalData = eventPremiumModalData;
  eventDiscordModalData = eventDiscordModalData;
  isOpenDiscordModal = false;
  isUserPremium = false;
  isAdmin = false;
  isHasDiscord = false;

  requestIndex: number;
  toolbarData = {
    arrowRouter: '/merfolk/pods',
    btnSlot: 'end',
    title: 'Pod',
  };

  imageLoading: boolean = false;
  properties;

  discordServerInviteLink = environment.discordServerInviteLink;
  isOpenFlagModal: boolean = false;
  flagData;

  private destroy$ = new Subject<void>();

  constructor(
    private podStore: PodStore,
    private activatedRouter: ActivatedRoute,
    private imagesService: ImagesService,
    private podsService: PodService,
    private userService: UserService,
    private storageHelper: StorageHelper,
    private alertController: AlertController,
    private eventsStore: EventsStore,
    private ng2ImgMaxService: Ng2ImgMaxService,
    private paymentsStore: PaymentsStore,
    private paymentService: PaymentsService,
    private dateService: DateService,
    private authService: AuthService,
    private platform: Platform,
    private popoverController: PopoverController,
    private toastController: ToastController,
    private mapService: MapService
  ) {
    this.podId = this.activatedRouter.snapshot.params.id;
    this.itemId = this.activatedRouter.snapshot.params.id;
    this.isMobile = this.platform.platforms().includes('capacitor');
  }

  ngOnInit() {
    // Set the appropriate back route based on navigation context
    const backRoute = this.mapService.getBackRoute('/merfolk/pods');
    this.toolbarData = {
      ...this.toolbarData,
      arrowRouter: backRoute,
    };

    mixpanel.init(environment.mixpanelToken, { debug: true });
    this.getUser();

    this.podStore.getItemByByValue({
      documentId: this.activatedRouter.snapshot.params.id,
    });

    this.listenPodDetails();

    this.podStore.selectShowFormModal().subscribe(isOpen => {
      this.isOpenPodFormModal = isOpen;
    });

    this.podStore.selectShowPendingModal().subscribe(isOpen => {
      this.showSuccessModal = isOpen;
    });

    this.eventsStore.selectShowPendingModal().subscribe(isOpen => {
      this.handleEventSuccessModalState(isOpen);
    });

    this.eventsStore.selectShowFormModal().subscribe(isOpen => {
      this.isOpenFormEventModal = isOpen;
    });

    this.eventsStore.getPreviewEvents({
      limit: 3,
      podId: this.activatedRouter.snapshot.params.id,
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // Clear navigation context when leaving the page
    this.mapService.clearNavigationContext();
  }

  trackEvent(event) {
    mixpanel.track(event);
  }

  openStatusModal() {
    this.showStatusModal = !this.showStatusModal;
  }

  async flagContent(slide) {
    slide.type = 'pods';

    this.flagData = slide;

    const functions = getFunctions();
    const isContentFlagged = httpsCallable(functions, 'isContentFlagged');
    const res = await isContentFlagged({
      itemId: slide.id,
      url: slide.image,
      type: this.flagData.type,
    });
    if (res.data === true) {
      this.isContentFlaggedModal = true;
    } else {
      this.isOpenFlagModal = true;
    }
  }

  joinPod() {
    if (this.pod?.invites?.length) {
      const invites = this.pod.invites.filter(
        invite => invite.invited !== this.userId
      );
      const newPod = Object.assign({
        ...this.pod,
        invites,
        participants: [...this.pod?.participants, this.userId],
      });
      this.updateItem(newPod, 'Successfully joined');
    } else {
      const newPod = Object.assign({
        ...this.pod,
        participants: [...this.pod?.participants, this.userId],
      });
      this.updateItem(newPod, 'Successfully joined');
    }
  }

  requestToJoin() {
    if (
      this.pod.joinMechanismArr.some(
        question => question.memberQuestion !== null
      )
    ) {
      this.podsService.showQuestionsModal.next(true);
    } else {
      this.presentConfirmAlert();
    }
  }

  async compressImage() {
    this.imagesService.compressedImages
      .pipe(takeUntil(this.destroy$))
      .subscribe(images => {
        if (images && images.length) {
          images.map(image => {
            return this.addToGallery(image);
          });
        }
      });
    await this.imagesService.compressMultiplyImages(this.isMobile);
  }

  async addToGallery(file) {
    if (!file) return;
    const uploadFile = await this.storageHelper.uploadPicture(file);
    this.imageLoading = true;
    uploadFile.task
      .snapshotChanges()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          uploadFile.fileRef
            .getDownloadURL()
            .pipe(takeUntil(this.destroy$))
            .subscribe(url => {
              const newPod = Object.assign({
                ...this.pod,
                gallery: [{ userId: this.userId, url }, ...this.pod.gallery],
              });
              this.gallery.push(url);

              this.updateItem(newPod, 'Successfully added');
            });
        })
      )
      .subscribe();
  }

  acceptModal(e) {
    if (e) {
      this.acceptRequest(this.requestIndex);
    }
  }

  rejectModal(e) {
    if (e) {
      this.rejectRequest(this.requestIndex);
    }
  }

  checkAnswersModal(i) {
    this.isOpenAnswersModal = !this.isOpenAnswersModal;
    this.requestIndex = i;
  }

  acceptRequest(i) {
    const newParticipant = this.pod?.memberRequests[i].id;
    const denied = this.pod.denied
      ? this.pod?.denied.filter(id => id !== newParticipant)
      : [];
    this.pod.memberRequests.splice(i, 1);
    if (
      this.pod?.denied?.length &&
      this.pod?.denied.find(item => item === newParticipant)
    ) {
      const newPod = Object.assign({
        ...this.pod,
        denied,
        participants: [...this.pod?.participants, newParticipant],
      });
      this.updateItem(newPod, 'Successfully added');
    } else {
      const newPod = Object.assign({
        ...this.pod,
        participants: [...this.pod?.participants, newParticipant],
      });
      this.updateItem(newPod, 'Successfully added');
    }
    this.isOpenAnswersModal = false;
  }

  rejectRequest(i: number) {
    if (!this.pod) {
      return;
    }
    const { memberRequests, denied } = this.pod;
    const blockedUser = memberRequests[i].id;
    const blockedUsers = denied
      ? denied.filter(id => id !== memberRequests[i].id)
      : [];
    this.pod.memberRequests.splice(i, 1);
    if (denied?.length && denied.find(item => item === blockedUser)) {
      const newPod = Object.assign({ ...this.pod });

      this.updateItem(newPod, 'Successfully denied');
    } else {
      const newPod = Object.assign({
        ...this.pod,
        denied: [...blockedUsers, blockedUser],
      });

      this.updateItem(newPod, 'Successfully denied');
    }

    this.isOpenAnswersModal = false;
  }

  setEvent = async () => {
    if (this.isUserPremium || this.isAdmin) {
      this.eventsStore.updateShowFormModal(true);
      return;
    }

    const hasMembership = await this.authService.getMembership(this.userId);
    if (hasMembership) {
      this.eventsStore.updateShowFormModal(true);
      return;
    }

    this.isUserPremiumModalOpen = false;
    this.isOpenDiscordModal = true;
  };

  closeEventModal(e) {
    e ? this.eventsStore.updateShowFormModal(false) : null;
  }

  async presentConfirmAlert() {
    const alert = await this.alertController.create({
      cssClass: 'alert',
      message:
        '<div class="color-dark d-flex flex-column ion-align-items-center"><ion-icon name="radio-button-on" class="font-24"></ion-icon><p class="font-16">Exciting News!</p><p class="font-14 font-opacity">Your future Pod is going to review your request! As soon as they\'ve accepted you, you\'ll be able to see their pictures, participate in their events and chat with them!</p></div>',
      buttons: [
        {
          text: 'OKAY',
        },
      ],
    });
    await alert.present();
  }

  async presentLeaveAlert() {
    const alert = await this.alertController.create({
      message:
        '<div class="color-dark d-flex flex-column ion-align-items-center"><ion-icon name="radio-button-on" class="font-24"></ion-icon><p class="font-16">Leaving a Pod?</p><p class="font-14">Are you sure you want to leave the Pod? That way you will no longer have access to the Pod\'s events, chat or pictures?</p></div>',
      buttons: [
        {
          text: 'NO, STAY',
        },
        {
          text: 'YES, LEAVE',
          handler: () => {
            this.leavePod();
            alert.dismiss('cancel', 'cancel');
            this.trackEvent('Pod Left');
          },
        },
      ],
    });
    await alert.present();
  }

  leavePod() {
    const newParticipants = this.pod.participants.filter(
      user => user !== this.userId
    );

    const newItem = Object.assign({
      ...this.pod,
      participants: newParticipants,
    });
    this.updateItem(newItem);
  }

  close(_e) {}

  listenPodDetails() {
    combineLatest([this.podStore.selectItem(), this.eventsStore.selectItems()])
      .pipe(
        skip(1),
        takeUntil(this.destroy$),
        filter(item => !!item),
        switchMap(([pod, events]) => {
          //? maybe letter
          // if (pod?.status !== 'approved' && pod?.creator.id !== this.userId) {
          //   this.route.navigate(['/merfolk/pods']);
          // }
          const userId = this.authService.isUserAuth().uid;
          this.events = this.getPodPreviewEvents(events);

          this.pod = pod;
          pod?.gallery?.length
            ? (this.isCanDeleteImage = this.pod.gallery[0].userId === userId)
            : null;
          this.isPendingJoinRequest = pod?.memberRequests
            ? pod?.memberRequests?.some(item => item.id === userId)
            : false;
          this.galleryUrls = pod?.gallery.map(
            pic => `url("${pic.url}") no-repeat center center / cover`
          );

          this.isCreator = pod?.creator.id === userId;
          this.isParticipant = this.pod?.participants.includes(userId);
          this.isCanApprove =
            (this.pod?.approveMembers === 'everyone can approve' ||
              pod?.creator.id === userId) &&
            this.isParticipant;

          this.isCanEdit =
            pod?.memberRights === 'everyone can edit/delete' &&
            this.isParticipant;
          if (pod?.participants?.length) {
            const members$ = pod.participants.map(user =>
              this.authService.getUserByUid(user)
            );
            combineLatest(members$).subscribe(result => {
              this.participants = result;
            });
          }

          const memberRequests$ = pod?.memberRequests?.map(user => {
            return this.authService.getUserByUid(user.id);
          });

          if (memberRequests$) {
            combineLatest(memberRequests$)
              .pipe(filter(result => !!result))
              .subscribe(result => {
                this.memberRequests = result.map((user, index) =>
                  Object.assign({
                    ...user,
                    answers: pod?.memberRequests[index]?.answers,
                  })
                );
              });
          }
          return pod?.creator.id
            ? this.authService.getUserByUid(pod?.creator.id)
            : null;
        }),
        filter(user => !!user)
      )
      .subscribe(user => (this.user = user));
  }

  getPodPreviewEvents(events) {
    const podEvents = (events || []).filter(
      event => event?.podName === this.podId
    );
    return this.dateService.getScheduledItems(podEvents, false);
  }

  closeEditModal() {
    this.podStore.updateShowFormModal(false);
  }

  handleOk(e) {
    e ? this.podStore.updateShowPendingModal(false) : null;
  }

  handleCancel(e) {
    e ? this.podStore.updateShowPendingModal(false) : null;
  }

  handleEventSuccessModalState(isOpen) {
    this.showEventSuccessModal = isOpen;
  }

  handleEventSuccessOk(e) {
    e ? this.eventsStore.updateShowPendingModal(false) : null;
  }

  handleEventSuccessCancel(e) {
    e ? this.eventsStore.updateShowPendingModal(false) : null;
  }
  openModal() {
    this.podStore.updateShowFormModal(true);
  }
  toggleGallery(i?) {
    if (i !== undefined) {
      this.slideIndex = i;
    }
    if (
      this.pod.gallery.length === 1 &&
      this.pod.gallery[0].userId === this.userId
    ) {
      this.isCanDeleteImage = true;
    }
    this.isOpen = !this.isOpen;

    this.config = {
      modules: [Navigation],
      loop: true,
      navigation: true,
      initialSlide: i,
      on: {
        activeIndexChange: function (swiper) {
          this.slideIndex = swiper.realIndex;
          this.isCanDeleteImage =
            this.pod.gallery[swiper.realIndex].userId === this.userId;
        }.bind(this),
      },
    };
  }

  removeImg(e) {
    if (e) {
      const gallery = this.pod.gallery;
      const removedImg = gallery[this.slideIndex];
      gallery.splice(this.slideIndex, 1);
      const newItem = Object.assign({
        ...this.pod,
        gallery,
      });
      this.storageHelper.deletePicture(removedImg);
      this.updateItem(newItem);
    }
  }

  async flagImg(e) {
    if (e) {
      const gallery = this.pod.gallery;
      const removedImg = gallery[this.slideIndex];
      this.flagData = removedImg;
      this.flagData.podId = this.podId;
      this.flagData.type = 'podGallery';
      const functions = getFunctions();
      const isContentFlagged = httpsCallable(functions, 'isContentFlagged');
      const res = await isContentFlagged({
        itemId: this.podId,
        url: removedImg.url,
        type: this.flagData.type,
      });
      if (res.data === true) {
        this.isContentFlaggedModal = true;
      } else {
        this.isOpenFlagModal = true;
      }
    }
  }

  closeModalDeleting(e) {
    if (e) this.showForDelete = false;
  }

  updateItem(newItem, msg?) {
    this.podStore.updateProfile(newItem);
    this.showForDelete = false;
    this.isOpen = false;
    this.podStore
      .selectLoading()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (!data) {
          this.isClose.next(true);
          this.imageLoading = false;
        }
      });
  }

  async goToDiscordChanel(link) {
    await this.podsService.givePermission(this.podId);
    window.open(link, '_blank');
  }

  async shareItem(event: Event) {
    if (event) {
      event.stopPropagation();
    }

    const postUrl = window.location.href;
    const postTitle = this.pod?.name || 'MerMapp Pod';
    const postText = this.pod?.description || 'Check out this pod on MerMapp!';

    const popover = await this.popoverController.create({
      component: ShareOptionsComponent,
      componentProps: {
        postUrl: postUrl,
        postTitle: postTitle,
        postText: postText,
        onOptionSelected: (option: string) => {
          this.handleShareOption(option, postUrl, postTitle, postText);
          popover.dismiss();
        },
      },
      event: event,
      translucent: true,
      backdropDismiss: true,
      alignment: 'center',
      side: 'top',
      arrow: true,
    });

    await popover.present();
  }

  async handleShareOption(
    option: string,
    postUrl: string,
    postTitle: string,
    postText: string
  ) {
    switch (option) {
      case 'copy':
        await this.copyToClipboard(postUrl);
        break;
      case 'facebook':
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            postUrl
          )}`,
          '_blank'
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?url=${encodeURIComponent(
            postUrl
          )}&text=${encodeURIComponent(postText)}`,
          '_blank'
        );
        break;
      case 'whatsapp':
        window.open(
          `https://api.whatsapp.com/send?text=${encodeURIComponent(
            `${postText} ${postUrl}`
          )}`,
          '_blank'
        );
        break;
      case 'email':
        window.open(
          `mailto:?subject=${encodeURIComponent(
            postTitle
          )}&body=${encodeURIComponent(`${postText} ${postUrl}`)}`,
          '_blank'
        );
        break;
      case 'native':
        await this.useNativeShare(postUrl, postTitle, postText);
        break;
    }
  }

  async copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      const toast = await this.toastController.create({
        message: 'Link copied to clipboard',
        duration: 2000,
        position: 'bottom',
      });
      await toast.present();
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  async useNativeShare(postUrl: string, title: string, text: string) {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: postUrl,
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error sharing:', error);
        }
      }
    } else {
      const toast = await this.toastController.create({
        message: 'Share functionality not available on this device',
        duration: 2000,
        position: 'bottom',
      });
      await toast.present();
    }
  }

  private getUser() {
    this.userService.currentUser$
      .pipe(
        takeUntil(this.destroy$),
        filter(user => !!user.uid)
      )
      .subscribe(user => {
        this.user = user;
        this.userId = user.uid;
        this.isUserPremium = this.userService.isPremium;
        this.isHasDiscord = !!user.discordLink;
        this.isAdmin = this.userService.isAdmin;
        mixpanel.identify(user.uid);
      });
  }
}

